import React, { useEffect, useRef, useState } from 'react';
import about2Img from "../../../assets/Images/director's-message/krunal_sir.png";
import about3Img from "../../../assets/Images/director's-message/munesh_sir.png";

// Edit names, roles, quotes and messages with the real director details.
const directors = [
  {
    id: 1,
    eyebrow: 'A WORD FROM OUR FOUNDER',
    name: 'Dr. Krunal Nagani (M.Sc. & Ph.D.)',
    role: 'Founder,Nutralike Group',
    quote:
      'Creating Reliable Wellness Solutions for Every Generation.',
    message:
      'To establish Nutralike as one of India’s top 5 nutraceutical exporters by 2030, driven by innovation, quality, and wellness.The Group is committed to creating products that empower healthier and happier lives globally.To strengthen Nutralike’s global presence by ensuring world-class quality, compliance, and innovation in nutraceutical manufacturing, with a special focus on effervescent technologies.Our commitment has always been towards quality, transparency, and long-term relationships - with our customers, partners, and community.Every product we create reflects years of experience, research, and dedication.As we move forward, our goal remains the same to empower individuals with safe, reliable, and effective wellness solutions.',
    image: about2Img,
    signature: 'Krunal Nagani',
  },
  {
    id: 2,
    eyebrow: 'A WORD FROM OUR DIRECTOR',
    name: 'Mr. Munesh Gajera (M. Pharm)',
    role: 'Co-Founder, Nutralike Group',
    quote:
      'Committed to Quality. Inspired by Better Health.',
    message:
      'At Nutralike, our journey of over 12 years has been guided by a clear and meaningful vision-to make high-quality nutraceutical products accessible, effective, and trustworthy for everyone. What began as a strong passion for health and wellness has grown into a brand built on science, innovation, and a deep understanding of evolving consumer needs. Over the years, we have seen a significant shift towards preventive healthcare and the essential role nutraceuticals play in daily life. This has continuously motivated us to innovate, improve, and deliver products that not only meet industry standards but genuinely contribute to better health and well-being.Our focus has always remained on quality, transparency, and building long-term relationships with our customers, partners, and community. Every product we develop reflects our commitment, experience, and dedication to excellence. As we move forward, we remain committed to empowering individuals with safe, reliable, and effective wellness solutions.',
    image: about3Img,
    signature: 'Munesh Gajera',
  },
];

const DirectorSection = ({ director, reversed, index, sectionVisible }) => {
  const ref = useRef(null);
  const [seen, setSeen] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setSeen(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  const visible = sectionVisible && seen;

  return (
    <article
      ref={ref}
      className={`grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center ${
        index > 0 ? 'mt-20 lg:mt-28' : ''
      }`}
    >
      {/* Image */}
      <div
        className={`lg:col-span-5 ${reversed ? 'lg:order-2' : ''} ${
          visible ? (reversed ? 'dw-from-right' : 'dw-from-left') : 'opacity-0'
        }`}
      >
        <div className="relative max-w-[460px] mx-auto lg:mx-0">
          {/* Subtle brand accent bar */}
         {/* <span
            className={`hidden lg:block absolute -bottom-3 ${
              reversed ? '-right-3' : '-left-3'
            } w-24 h-24 rounded-2xl pointer-events-none`}
            style={{
              background:
                'linear-gradient(135deg, rgba(53,89,49,0.10) 0%, rgba(164,190,44,0.18) 100%)',
            }}
            aria-hidden="true"
          /> */}
          <img
            src={director.image}
            alt={director.name}
            className="relative w-full h-auto rounded-2xl object-cover shadow-[0_25px_55px_-25px_rgba(53,89,49,0.35)]"
            loading="lazy"
          />
        </div>
      </div>

      {/* Content */}
      <div
        className={`lg:col-span-7 ${reversed ? 'lg:order-1' : ''} ${
          visible ? 'dw-fade-up' : 'opacity-0'
        }`}
        style={{ animationDelay: visible ? '150ms' : '0ms' }}
      >
        {/* Eyebrow */}
        <div className="flex items-center gap-3">
          <span className="h-px w-8 bg-[#A4BE2C]" />
          <p className="text-[#A4BE2C] tracking-[0.4em] text-[11px] font-semibold">
            {director.eyebrow}
          </p>
        </div>

        {/* Name */}
        <h2 className="font-serif text-[#355931] text-3xl sm:text-4xl md:text-[44px] tracking-tight leading-tight mt-4">
          {director.name}
        </h2>

        {/* Role */}
        <p className="text-gray-500 text-sm sm:text-[15px] mt-2 tracking-wide">
          {director.role}
        </p>

        {/* Divider */}
        <div
          className="h-[2px] w-16 mt-6"
          style={{
            background:
              'linear-gradient(90deg, #355931 0%, #A4BE2C 100%)',
          }}
        />

        {/* Quote */}
        <blockquote className="relative mt-7 pl-6 sm:pl-8">
          <span
            className="absolute -left-1 top-0 font-serif text-[#A4BE2C] text-5xl sm:text-6xl leading-none select-none"
            aria-hidden="true"
          >
            &ldquo;
          </span>
          <p className="font-serif italic text-[#355931] text-lg sm:text-xl leading-relaxed">
            {director.quote}
          </p>
        </blockquote>

        {/* Message */}
        <p className="text-gray-600 text-[14.5px] sm:text-base mt-6 leading-relaxed">
          {director.message}
        </p>

        {/* Signature */}
        <div className="flex items-center gap-3 mt-8">
          {/* <span className="h-px w-10 bg-[#355931]/40" /> */}
          <span className="font-serif italic text-[#355931] text-lg sm:text-xl">
            — {director.signature}
          </span>
        </div>
      </div>
    </article>
  );
};

const DirectorWord_Message = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const node = sectionRef.current;
    if (!node) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.05 }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="relative overflow-hidden bg-white pt-20 pb-10 sm:pt-24 sm:pb-12 px-4 sm:px-6 lg:px-10"
    >
      <style>{`
        @keyframes dw-fade-up {
          0%   { opacity: 0; transform: translateY(20px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        @keyframes dw-slide-from-left {
          0%   { opacity: 0; transform: translateX(-32px); }
          100% { opacity: 1; transform: translateX(0); }
        }
        @keyframes dw-slide-from-right {
          0%   { opacity: 0; transform: translateX(32px); }
          100% { opacity: 1; transform: translateX(0); }
        }
        .dw-fade-up    { animation: dw-fade-up 900ms cubic-bezier(0.2, 0.8, 0.2, 1) both; }
        .dw-from-left  { animation: dw-slide-from-left 900ms cubic-bezier(0.2, 0.8, 0.2, 1) both; }
        .dw-from-right { animation: dw-slide-from-right 900ms cubic-bezier(0.2, 0.8, 0.2, 1) both; }
      `}</style>

      <div className="relative max-w-6xl mx-auto">
        {/* Section header */}
        <div className="text-center max-w-3xl mx-auto mb-16 lg:mb-20">
          <div
            className={`flex items-center justify-center gap-3 mb-5 ${
              isVisible ? 'dw-fade-up' : 'opacity-0'
            }`}
          >
            <span className="h-px w-8 bg-[#A4BE2C]" />
            <span className="text-[#A4BE2C] tracking-[0.4em] text-[11px] font-semibold">
              MESSAGE FROM LEADERSHIP
            </span>
            <span className="h-px w-8 bg-[#A4BE2C]" />
          </div>

<h2
  className={`font-serif text-[#355931] text-4xl sm:text-5xl md:text-[52px] tracking-tight leading-[1.05] ${
    isVisible ? 'dw-fade-up' : 'opacity-0'
  }`}
  style={{ animationDelay: isVisible ? '120ms' : '0ms' }}
>
  Inspiring Innovation,{" "}
  
  <span
    className="
      bg-gradient-to-r
      from-[#355931]
      via-[#6D8C2E]
      to-[#A4BE2C]
      bg-clip-text
      text-transparent
    "
  >
    Building Trust
  </span>
</h2>

          <div
            className={`mx-auto mt-6 h-[2px] w-24 ${
              isVisible ? 'dw-fade-up' : 'opacity-0'
            }`}
            style={{
              animationDelay: isVisible ? '240ms' : '0ms',
              background:
                'linear-gradient(90deg, transparent 0%, #355931 30%, #A4BE2C 70%, transparent 100%)',
            }}
          />

          <p
            className={`text-gray-600 max-w-2xl mx-auto text-[15px] sm:text-base mt-6 leading-relaxed ${
              isVisible ? 'dw-fade-up' : 'opacity-0'
            }`}
            style={{ animationDelay: isVisible ? '360ms' : '0ms' }}
          >
            At Nutralike, our vision goes beyond manufacturing - we are committed to creating innovative, science-backed wellness solutions that deliver quality, consistency, and long-term value. Every product we develop reflects our dedication to research, transparency, and customer success.
            </p>
        </div>

        {/* Director sections — alternating layout */}
        {directors.map((director, i) => (
          <DirectorSection
            key={director.id}
            director={director}
            index={i}
            reversed={i % 2 === 1}
            sectionVisible={isVisible}
          />
        ))}
      </div>
    </section>
  );
};

export default DirectorWord_Message;
